import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=3b2333b2&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=3b2333b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2333b2",
  null
  
)

export default component.exports